import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import AddAddress from './addAddress'
import * as AC from '../../actions/actionCreators'

function mapStateToProps(state) { 
	return {
        addresses: state.address.addresses,
        addressesByLicense: state.address.addressesByLicense,
        target: state.target.actualTarget,
        isSaving: state.address.isSaving,
        isLoadingTarget: state.target.isLoading,
        isLoadingAddresses: state.address.isLoading,
        errorTarget: state.target.error,
        errorAddress: state.address.error,
        errorRequest: state.request.error,
        visitorTerritory: state.profile.visitorTerritory
}};

function mapDispatchToProps(dispatch) {
    return({
        fetchAddresses: (city, postalCode, address, hco) => { dispatch(AC.AddressListLoadingStarted(city, postalCode, address, hco) ) },
        fetchTargetAddresses: (license) => { dispatch(AC.AddressListByLicenseLoadingStarted(license) ) },
        fetchTarget: (license) => { dispatch(AC.TargetLoadingStarted(license) ) },
        addAddressToPanel: (visitorTerritory, license, city, postalCode, address, hco) => { dispatch(AC.RequestAddExistingAddressStarted(visitorTerritory, license, city, postalCode, address, hco) ) },
        clearAddressUi: () => { dispatch(AC.ClearAddressUi()) },
        clearRequestUi: () => { dispatch(AC.ClearRequestUi()) },
        clearTargetUi: () => { dispatch(AC.ClearTargetUi()) }
    })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddAddress));